import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { yupResolver } from '@hookform/resolvers/yup';
import { Modal, Form, Row, Col, Image, Button } from 'react-bootstrap';

import InputGroupText from '@components/InputGroupText/InputGroupText';
import LoaderBtn from '@components/LoaderBtn/loaderBtn';

import {
    cancelButtonColor,
    confirmButtonColor,
} from '@constants/general.const';

import { faUserShield } from '@fortawesome/pro-light-svg-icons';
import newRole from '@images/new-role.svg';

import { updateCurrentStep } from '@app/Auth/Login/loginSlice';
import { addRoleData } from '@app/CreateOrganization/step4/functions';

import { IStep4Props } from './step4.interface';

const RolesPopupStep4 = ({
    show,
    getData,
    handleClose,
    organizationId,
}: any) => {
    const dispatch = useDispatch<any>();

    const { roleStep4Data } = useSelector((state: any) => state);
    const { roleData, isAddRoleData } = roleStep4Data;

    const schema = Yup.object({
        role_name: Yup.string().required('Role Name is a required field'),
    }).required();

    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors, isDirty },
    } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: roleData,
        mode: 'onBlur',
    });

    const HandleChange = async (data: IStep4Props) => {
        const sendData = { ...data, nanoId: organizationId };
        const { payload } = await dispatch(addRoleData(sendData));
        const { data: payloadData } = payload || {};
        if (payloadData?.message !== '' && payloadData?.status) {
            dispatch(updateCurrentStep(payload));
            getData();
            handleClose();
            setValue('role_name', '');
        } else {
            toast.error(payload?.message);
        }
    };

    const onClose = async () => {
        if (isDirty) {
            Swal.fire({
                title: 'Warning',
                html:
                    'Are you sure you want to close this form? <br/> ' +
                    'All changes made will be lost.',
                allowOutsideClick: false,

                icon: 'warning',
                showCancelButton: true,
                cancelButtonColor: cancelButtonColor,
                confirmButtonColor: confirmButtonColor,
                cancelButtonText: 'No',
                confirmButtonText: 'Yes',
            }).then(async (result) => {
                if (result?.isConfirmed) {
                    handleClose();
                    setValue('role_name', '');
                }
            });
        } else {
            handleClose();
            setValue('role_name', '');
        }
    };

    return (
        <Modal show={show} onHide={onClose} backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title className="fs-5 fw-semibold">
                    Add New Role
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <Form onSubmit={handleSubmit(HandleChange)}>
                    <Row className="justify-content-center">
                        <Col md={12} className="text-center">
                            <Image src={newRole} alt="building icon" />
                        </Col>
                        <Col md={12} className="my-3">
                            <Controller
                                name={`role_name`}
                                control={control}
                                render={({
                                    field: { onChange, value },
                                }: any) => (
                                    <>
                                        <InputGroupText
                                            onChangeFunc={onChange}
                                            value={value}
                                            id={`role_name`}
                                            inputName={`role_name`}
                                            inputType={'text'}
                                            placeholder={'Role Name'}
                                            inputGroupClassName="mfnw__input-group"
                                            label={null}
                                            tabIndex={1}
                                            icon={faUserShield}
                                            disabled={false}
                                            autoFocus={true}
                                            errorText={
                                                errors?.role_name?.message
                                            }
                                        />
                                    </>
                                )}
                            />
                        </Col>
                        <Col md={12}>
                            <Button
                                variant="primary w-100 mt-3 text-uppercase"
                                className="button__details"
                                type="submit"
                                tabIndex={2}
                                disabled={isAddRoleData}
                            >
                                {isAddRoleData ? <LoaderBtn /> : 'SAVE'}
                            </Button>
                            <Button
                                className="btn-cancel mt-4 w-100 text-uppercase fw-semibold"
                                onClick={() => onClose()}
                                tabIndex={3}
                            >
                                CANCEL
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default RolesPopupStep4;
